import React from 'react';
import { Form, Col, Row, Button, Navbar, Container, Image, Spinner } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import GuestSiteMenu from "../guest_menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from "react-ga4";

class AppInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            input: {
                DefaultConnStr                  :  'N/A',          
                BolandDataBase                  :  'N/A',         
                JwtTokenServer                  :  'N/A',         
                PasswordResetLink               :  'N/A',      
                trainingRegistrationAdminEmails : 'N/A', 
                DocLinkAPI                      :  'N/A',             
                SalesforceUrl                   :  'N/A',          
                PayfabricUrl                    :  'N/A',           
            },
            showForm: false,
            errors: {},
            loading: false,
        };
        axios.get(`${Constants.apiURL}/api/Identity/GetAppInfo`).then(response => {
            if (response.data) {
                this.state.input.DefaultConnStr                  = `${response.data.defaultConnStr                 }`;
                this.state.input.BolandDataBase                  = `${response.data.bolandDataBase                 }`;
                this.state.input.JwtTokenServer                  = `${response.data.jwtTokenServer                 }`;
                this.state.input.PasswordResetLink               = `${response.data.passwordResetLink              }`;
                this.state.input.TrainingRegistrationAdminEmails = `${response.data.trainingRegistrationAdminEmails}`;
                this.state.input.DocLinkAPI                      = `${response.data.docLinkAPI                     }`;
                this.state.input.SalesforceUrl                   = `${response.data.salesforceUrl                  }`;
                this.state.input.PayfabricUrl                    = `${response.data.payfabricUrl                   }`;
            }
            else {
                this.state.input.DBName = "Not available";
            }
            this.setState({ loading: false });
        }).catch((response) => {
        });



    }


    render() {
        var SQLSrv = this.state.input.DefaultConnStr.split(';');
        var BolanDB = this.state.input.BolandDataBase.split(';');

        return (
            <div>
                <GuestSiteMenu currentPage='register' />
                <Form  noValidate >
                    <Row style={{ padding: '10px', margin: '10px', maxWidth: '1200px' }} className="mb-3">
                        <Col md={8}>
                            <Form.Label className="form-header">Client Portal Configuration Property Reference</Form.Label>
                            <div className="form-header" style={{ fontSize: '16px', marginTop: '-5px', paddingTop: '0px', fontWeight: 'bold',height:'36px' }}>URL: {Constants.apiURL}</div>

                            <div style={{ fontSize: '16px', marginTop: '-5px', paddingTop: '0px', fontWeight: 'bold' }}>SQL Server</div><ul>
                                <li>{SQLSrv[0]}</li>
                                <li>{SQLSrv[1]}</li>
                            </ul>
                            <div style={{ fontSize: '16px', marginTop: '-5px', paddingTop: '0px', fontWeight: 'bold' }}>Bolan Database</div>
                            <ul>
                                <li>{BolanDB[0]}</li>
                                <li>{BolanDB[1]}</li>
                            </ul>

                            <div style={{ fontSize: '16px', marginTop: '-5px', paddingTop: '0px', fontWeight: 'bold' }}>JwtToken Server</div><ul>                                
                                <li>{this.state.input.JwtTokenServer}</li>
                            </ul>
                            <div style={{ fontSize: '16px', marginTop: '-5px', paddingTop: '0px', fontWeight: 'bold' }}>Password Reset Link</div><ul>                                
                                <li>{this.state.input.PasswordResetLink               }</li>                                
                            </ul>
                            <div style={{ fontSize: '16px', marginTop: '-5px', paddingTop: '0px', fontWeight: 'bold' }}>Training Registration Admin Emails</div><ul>                                
                                <li>{this.state.input.TrainingRegistrationAdminEmails }</li>
                            </ul>
                            <div style={{ fontSize: '16px', marginTop: '-5px', paddingTop: '0px', fontWeight: 'bold' }}>DocLink API</div><ul>                                
                                <li>{this.state.input.DocLinkAPI                      }</li>
                            </ul>
                            <div style={{ fontSize: '16px', marginTop: '-5px', paddingTop: '0px', fontWeight: 'bold' }}>Salesforce Url                   </div><ul>                                
                                <li>{this.state.input.SalesforceUrl                   }</li>
                            </ul>
                            <div style={{ fontSize: '16px', marginTop: '-5px', paddingTop: '0px', fontWeight: 'bold' }}>Payfabric Url                    </div>
                            <ul>                                
                                <li>{this.state.input.PayfabricUrl                    }</li>
                            </ul>
                            {/*<ul>*/}
                            {/*    <li>Timeout (seconds){getTimeoutSeconds()}</li>*/}
                            {/*</ul>*/}
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

export default AppInfo;